var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56348 14.5125C7.56348 13.546 8.34698 12.7625 9.31348 12.7625H46.6468C47.6133 12.7625 48.3968 13.546 48.3968 14.5125C48.3968 15.4789 47.6133 16.2625 46.6468 16.2625H9.31348C8.34698 16.2625 7.56348 15.4789 7.56348 14.5125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56348 28.5125C7.56348 27.546 8.34698 26.7625 9.31348 26.7625H46.6468C47.6133 26.7625 48.3968 27.546 48.3968 28.5125C48.3968 29.479 47.6133 30.2625 46.6468 30.2625H9.31348C8.34698 30.2625 7.56348 29.479 7.56348 28.5125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56348 42.5124C7.56348 41.546 8.34698 40.7625 9.31348 40.7625H46.6468C47.6133 40.7625 48.3968 41.546 48.3968 42.5124C48.3968 43.4789 47.6133 44.2624 46.6468 44.2624H9.31348C8.34698 44.2624 7.56348 43.4789 7.56348 42.5124Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerButton);
export default __webpack_public_path__ + "static/media/hamburger-button.427461cf.svg";
export { ForwardRef as ReactComponent };